module.exports = __webpack_public_path__ + "static/media/tint-slash.ca6e3ae1.svg";